module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n4n6n9r-f66d4f49c0614245f3f0f38cd7f03511.svg";